export {}

export const getPrice = (quantity: number) => {
  if (quantity < 2) {
    return 3
  } else if (quantity < 10) {
    return 2
  } else if (quantity < 50) {
    return 1.5
  } else if (quantity < 100) {
    return 1
  } else if (quantity < 200) {
    return 0.85
  } else if (quantity < 500) {
    return 0.75
  } else if (quantity < 1000) {
    return 0.6
  } else if (quantity < 3000) {
    return 0.5
  } else if (quantity < 5000) {
    return 0.4
  } else if (quantity < 10000) {
    return 0.3
  } else {
    return 0.25
  }
}
